class SafeAudio {
    audio

    constructor (audioURL) {
      this.audio = new Audio(audioURL)
      this.audio.volume = 0.4
    }

    play () {
      const playPromise = this.audio.play()
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {})
      }
    }

    pause () {
      this.audio.pause()
    }

    addEventListener (event, callback) {
      this.audio.addEventListener(event, callback)
    }

    get currentTime () {
      return this.audio.currentTime
    }
    set currentTime (time) {
      this.audio.currentTime = time
    }

    get duration () {
      return this.audio.duration
    }

    set onended (callback) {
      this.audio.onended = callback
    }
}

export default SafeAudio
